import request from 'config/axios'

const URL = '/kingsman/v1/customers/unified-suitability'

export const getInvestorProfile = () => request.get(URL) // eslint-disable-line
